export class EntityClasses {
}
